{
  "auth-process-pages": {
    "login-process-steps": {
      "step-1": {
        "title": "Nom d'utilisateur",
        "description": "Votre email ou numéro de téléphone"
      },
      "step-2": {
        "title": "Sécurité",
        "description": "Veuillez saisir les informations requises"
      }
    },
    "register-process-steps": {
      "step-1": {
        "title": "Informations personnelles",
        "description": "Veuillez remplir le formulaire d'information"
      },
      "step-2": {
        "title": "Données de connexion",
        "description": "Veuillez définir vos données de connexion"
      },
      "step-3": {
        "title": "Vérifier le compte",
        "description": "Vous recevrez un code de confirmation par email"
      },
      "step-4": {
        "title": "Compte créé",
        "description": "Votre compte est créé !"
      }
    },
    "meta": {
      "login": {
        "title": "Connexion",
        "description": "Se connecter à Beauty Booking"
      },
      "register": {
        "title": "Inscription",
        "description": "Enregistrez votre nouveau compte"
      }
    }
  }
}
